module.exports = __webpack_public_path__ + "static/media/critterworld1.60e0deb3.jpg";